// extracted by mini-css-extract-plugin
export default {"scrollListWithPagination":"RtdQg","arrowPicto":"eyEvv"};